module.exports = __webpack_public_path__ + "static/media/function.31be11d1.jpg";